import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { Divider } from "@material-ui/core";
import { bindActionCreators } from "redux";

import * as Menu from "../../../MenuConfig";
import SchoolSelector from "./SchoolSelector";
import { MenuOption } from "./MenuOption";
import { toAbsoluteUrl } from "../../../../_helpers";
import { getPermisssion } from "../../../../../app/crud/api/Permission.crud";
import * as permissionDuck from "../../../../../redux/ducks/permissions.duck";

// TZ-793: Get Support opens the Notion help doc in a new tab instead of
// the old in-app iframe embed, whose deep/nested links failed to load.
const SUPPORT_NOTION_URL =
  "https://www.notion.so/331804db6a704506960e196e4c3c81bb";

function AsideMenuList({ permissionsActions, layoutProps }) {
  const [itemss, setItems] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { selected_school } = useSelector((state) => state.school);
  const [permissions, setPermissions] = useState([]);
  // Which school the entries in `permissions` belong to — null once no school
  // is selected, undefined before anything has been fetched.
  const [permissionsSchoolId, setPermissionsSchoolId] = useState(undefined);

  // Whether `permissions` describes the school currently selected. Without
  // this the render below treated "not fetched yet" as "no restrictions" and
  // briefly showed gated items to users who can't open them.
  //
  // Derived during render rather than held as a flag the effect resets:
  // effects run after paint, so switching schools committed one render in
  // which the selection was already the new school while the flag still said
  // "loaded" and `permissions` still held the previous school's entries.
  // Comparing here closes that window — the mismatch is visible immediately.
  const permissionsLoaded =
    permissionsSchoolId === (selected_school ? selected_school.id : null);

  useEffect(() => {
    let itemss = [...Menu.default.aside.items];
    // Switching schools starts a second request while the first is still in
    // flight, and the replies can land out of order. The cleanup below flips
    // this when selected_school changes, so a late reply from the superseded
    // request is dropped. Comparing school ids inside the callback would not
    // work: `selected_school` in this closure is the value captured when the
    // effect ran, so it can never differ from itself.
    let superseded = false;

    if (selected_school != null) {
      // Neither of these depends on the response. Leaving them inside .then()
      // meant a rejected request left the sidebar with its initial empty list
      // and no navigation at all — there was nothing to "fail open" to. Render
      // the menu first; permissionsLoaded is what gates individual items.
      itemss[1].title = "Share Resources";
      setItems(Menu.default.aside.items);

      const schoolId = selected_school.id;
      getPermisssion(schoolId)
        .then((data) => {
          if (superseded) return;
          // const permission = data.find(x => !x.read && x.module_clave === 'dash001');

          //if(!permission?.read)history.push('/users')
          permissionsActions.setPermissions(data);
          setPermissions(data);
          setPermissionsSchoolId(schoolId);
        })
        .catch(() => {
          if (superseded) return;
          // Fail open, and drop anything carried over from a previously
          // selected school so it can't keep gating. Losing navigation to a
          // network blip is worse than offering a link the API will refuse
          // anyway — the server enforces access itself.
          setPermissions([]);
          setPermissionsSchoolId(schoolId);
        });
    } else {
      // No school selected — nothing is fetched and nothing gates. Clear the
      // permissions of the school just deselected; left in place they would
      // keep gating items in a context they no longer apply to.
      setPermissions([]);
      setPermissionsSchoolId(null);
      itemss.splice(1, 1);
      setItems(itemss);
    }

    return () => {
      superseded = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected_school]);

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {(user.is_admin || (user && user && user.is_admin)) && (
          <li style={{ padding: "0 25px", marginBottom: 25 }}>
            <SchoolSelector />
          </li>
        )}
        {/*begin::1 Level*/}
        {itemss.map((item) => {
          const permission = permissions.find(
            (x) => x.module_clave === item.clave
          );
          if (
            (item.admin && !user.is_admin) ||
            (item.staff_member_admin &&
              !user.staff_member_admin &&
              !user.is_admin)
          ) {
            return <></>;
          } else if (
            item.clave === undefined ||
            (permissionsLoaded &&
              (permissions.length === 0 || permission?.read === true))
          )
            return <MenuOption item={item} key={item.title} />;
          else
            return null;
          // item.title = item.title === 'organization_hub' ?nameSelectedSchool + " Hub" : item.title
          // return ((item.admin && !user.is_admin) || (item.staff_member_admin && (!user.staff_member_admin && !user.is_admin))) ? <></> : (
          //   <MenuOption item={item} key={item.title } />
          // );
        })}
        <Divider />
        <li className="menu-item">
          <a
            className="menu-link menu-toggle"
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.google.com/forms/d/e/1FAIpQLSecHYEtASE941oGMtTn2gP2TbNyJyw95IkZaVq_EDB9VXkYwg/viewform?usp=sf_link"
          >
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  `/media/svg/icons/Communication/Incoming-box.svg`
                )}
              />
            </span>
            <span className="menu-text">Share Feedback</span>
          </a>
        </li>
        <li className="menu-item">
          {/* TZ-793: plain native anchor (same pattern as Share Feedback above)
              so it opens Notion in a new tab WITHOUT touching the current tab.
              The previous onClick + window.open + href="#" reloaded the
              dashboard tab behind the new one. */}
          <a
            className="menu-link menu-toggle"
            target="_blank"
            rel="noopener noreferrer"
            href={SUPPORT_NOTION_URL}
          >
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(`/media/svg/icons/Code/Question-circle.svg`)}
              />
            </span>
            <span className="menu-text">Get Support</span>
          </a>
        </li>
        {/*end::1 Level*/}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  permissionsActions: bindActionCreators(permissionDuck.actions, dispatch),
});

export default connect(null, mapDispatchToProps)(AsideMenuList);
